<template>
  <svg viewBox="0 0 64 64">
    <svg id="dak">
      <g>
        <path
          d="M63.1,37.1H32.6L18,20.8c-0.2-0.2-0.4-0.3-0.6-0.3h0c-0.2,0-0.5,0.1-0.6,0.3L2,37.4c-0.3,0.4-0.3,0.9,0.1,1.2
                c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.5-0.1,0.6-0.3l14.1-15.8l14.2,15.8c0.2,0.2,0.4,0.3,0.6,0.3h30.9c0.5,0,0.9-0.4,0.9-0.9
                S63.6,37.1,63.1,37.1z"
        />
        <path
          d="M17.6,28.3c-0.2-0.2-0.4-0.3-0.6-0.3h0c-0.2,0-0.5,0.1-0.6,0.3l-5,5.6c-0.3,0.4-0.3,0.9,0.1,1.2c0.2,0.1,0.4,0.2,0.6,0.2
                c0.2,0,0.5-0.1,0.6-0.3l3.5-4v13.7c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9V31.2l3.5,3.9c0.3,0.4,0.9,0.4,1.2,0.1
                c0.4-0.3,0.4-0.9,0.1-1.2L17.6,28.3z"
        />
        <path
          d="M33.2,35c0.2,0.2,0.4,0.3,0.7,0.3h29.3c0.3,0,0.7-0.2,0.8-0.5c0.1-0.3,0.1-0.7-0.1-0.9L47.3,15.3
                c-0.2-0.2-0.4-0.3-0.6-0.3H17.4h0c-0.2,0-0.4,0.1-0.5,0.2c0,0,0,0-0.1,0c0,0,0,0-0.1,0.1L0.2,33.9c-0.3,0.4-0.3,0.9,0.1,1.2
                c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.5-0.1,0.7-0.3l15.8-17.8L33.2,35z M46.2,16.7l15,16.8H34.3l-15-16.8H46.2z"
        />
      </g>
    </svg>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconDak extends Vue {}
</script>
